<div class="content-wrapper">
    <div class="tabs">
        <button *ngFor="let tab of servicesName" (click)="selectTab(tab.value)"
            [ngClass]="{ active: selectedTab() === tab.value}">
            <!--<mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>-->
            {{ tab.label }}
        </button>
    </div>

    <!-- TODOS -->
    <div class="container">
        <div class="filters">
            <button #btnActive (click)="selectType('active')" [class]="selectedType() == 'active'? 'active':'' ">
                <div class="circle-container">
                    <mat-icon class=".icon-btn">check</mat-icon>
                </div>
                Activos
            </button>
            <button #btnEnd (click)="selectType('end')" [class]="selectedType() == 'end'? 'active':'' ">
                <div class="circle-container">
                <mat-icon class=".icon-btn">remove</mat-icon>
                    </div>
                Cerrados
            </button>
            <button (click)="toggleSortOrder()" [class]="'sort-btn'">
                <div class="circle-container">
                    <mat-icon class=".icon-btn">{{ sortOrder() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                </div>
                {{ sortOrder() === 'asc' ? 'Más antiguo' : 'Más reciente' }}
            </button>
         </div>
    </div>     
    
    <ng-container>
        <div class="card-container" *ngIf="selectedTab() === 'Todos' && paginatedAssistance().length > 0; else filteredView">
            <div class="card" *ngFor="let assistance of paginatedAssistance()">
                <div class="card-header">
                    <mat-icon class="icon">{{ getIconForService(assistance.dsservicio) }}</mat-icon>
                    <span class="title">{{ assistance.dssubservicio}}</span>
                    <span [class]="getStatusClass(assistance.clestatus)" >
                       <mat-icon class="icon-status">check_circle</mat-icon>
                        <p class="label-status">{{ getStatusDisplay(assistance.clestatus)}}</p>
                    </span>
                </div>
                <div class="card-content">
                    <p><span>Expediente:</span>&nbsp;{{assistance.clexpediente || 'N/A'}}</p>
                    <p><span>Solicitante:</span>&nbsp;{{getSolicitante(assistance)}}</p>
                    <p *ngIf="isOfiiceDoctor(assistance)"><span>Especialidad:</span>&nbsp;{{(assistance.descripcionocurrido)}}</p>
                    <p><span>Estatus:</span>&nbsp;{{assistance.dsEstatusBanamex || assistance.dssubestatusbanamex || 'N/A'}}</p>
                    <p><span>No. Póliza:</span>&nbsp;{{assistance.clave || 'N/A'}}</p>
                    <p><span>Producto:</span>&nbsp;{{assistance.nombre || 'N/A'}}</p>
                    <div *ngIf="isCheckUpMedical(assistance)">
                        <p><span>Estudio:</span>&nbsp;{{ getCheckUpInfo(assistance).estudio }}</p>
                        <p><span>Laboratorio:</span>&nbsp;{{ getCheckUpInfo(assistance).laboratorio }}</p>
                        <p><span>Dirección:</span>&nbsp;{{ getCheckUpInfo(assistance).direccion }}</p>
                    </div>
                    <ng-container *ngIf="hasAddress(assistance)">
                        <p><span>Dirección:</span>&nbsp;{{assistance.descripcionocurrido}}</p>
                    </ng-container>
                    <p><span>Fecha:</span>&nbsp;{{formatDate(assistance.fecharegistro || assistance.fechatermino)}}</p>
                </div>
                <div class="card-footer">
                    <button mat-icon-button 
                    (click)="goToDetail(assistance?.clexpediente, assistance)"
                    [disabled]="!assistance?.clexpediente"
                    >
                        <span>Ver detalle</span>
                        <mat-icon class="icon" matSuffix>arrow_circle_right</mat-icon>
                    </button>
                </div>
            </div>
        </div>

    </ng-container>

    <ng-template #filteredView>
       <div class="card-container" *ngIf="paginatedAssistance().length > 0; else noRequests">
            <div class="card" *ngFor="let assistance of paginatedAssistance()">
                <div class="card-header">
                    <mat-icon class="icon">{{ getIconForService(assistance.dsservicio) }}</mat-icon>
                    <span class="title">{{ assistance.dssubservicio}}</span>
                    <span [class]="getStatusClass(assistance.clestatus)" >
                        <mat-icon class="icon-status">check_circle</mat-icon>
                        <p class="label-status">{{ getStatusDisplay(assistance.clestatus)}}</p>
                    </span>
                </div>
                <div class="card-content">
                    <p><span>Expediente:</span>&nbsp;{{assistance.clexpediente || 'N/A'}}</p>
                    <p><span>Solicitante:</span>&nbsp;{{getSolicitante(assistance)}}</p>
                    <p *ngIf="isOfiiceDoctor(assistance)"><span>Especialidad:</span>&nbsp;{{(assistance.descripcionocurrido)}}</p>
                    <p><span>Estatus:</span>&nbsp;{{assistance.dsEstatusBanamex || assistance.dssubestatusbanamex || 'N/A' }}</p>
                    <p><span>No. Póliza:</span>&nbsp;{{assistance.clave || 'N/A'}}</p>
                    <p><span>Producto:</span>&nbsp;{{assistance.nombre || 'N/A'}}</p>
                    <div *ngIf="isCheckUpMedical(assistance)">
                        <p><span>Estudio:</span>&nbsp;{{ getCheckUpInfo(assistance).estudio }}</p>
                        <p><span>Laboratorio:</span>&nbsp;{{ getCheckUpInfo(assistance).laboratorio }}</p>
                        <p><span>Dirección:</span>&nbsp;{{ getCheckUpInfo(assistance).direccion }}</p>
                    </div>
                    <ng-container *ngIf="hasAddress(assistance)">
                        <p><span>Dirección:</span>&nbsp;{{assistance.descripcionocurrido}}</p>
                    </ng-container>
                    <p><span>Fecha:</span>&nbsp;{{formatDate(assistance.fecharegistro || assistance.fechatermino)}}</p>
                </div>
                <div class="card-footer">
                    <button mat-icon-button 
                    (click)="goToDetail(assistance?.clexpediente, assistance)"
                    [disabled]="!assistance?.clexpediente"
                    >
                        <span>Ver detalle</span>
                        <mat-icon class="icon" matSuffix>arrow_circle_right</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        
        <ng-template #noRequests>
            <div class="no-requests">
                <mat-icon>inbox</mat-icon>
                <p>No hay solicitudes disponibles</p>
            </div>
        </ng-template>
    </ng-template>

    
    <!-- Paginación -->
    <div class="pagination-container">
        <button class="pagination-btn prev-btn" (click)="prevPage()" [disabled]="currentPage() === 1">
            <mat-icon>chevron_left</mat-icon>
        </button>
        
        <div class="pagination-info">
            <span class="page-text">Página {{ currentPage() }} de {{ totalPages() }}</span>
        </div>
        
        <button class="pagination-btn next-btn" (click)="nextPage()" [disabled]="currentPage() === totalPages()">
            <mat-icon>chevron_right</mat-icon>
        </button>
        </div>
</div>

<app-floating-assistance-button></app-floating-assistance-button>